import React from 'react';
import { string } from 'prop-types';

import { PRIMITIVE_COLORS } from 'constants/quartz/primitive_colors';

const DashIcon = ({ fill, height, width, ...rest }) => {
    return (
        <svg {...rest} width={width} height={height} viewBox="0 0 12 4">
            <rect x="0" y="1" width="12" height="2" rx="1" fill={fill} />
        </svg>
    );
};

DashIcon.propTypes = {
    fill: string,
    height: string,
    width: string,
};

DashIcon.defaultProps = {
    fill: PRIMITIVE_COLORS.neutral.black,
    height: '4',
    width: '12',
};

export default DashIcon;
